import * as React from 'react';
import { Typography } from '@material-ui/core';
import { StyleRulesCallback, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import MultilineText from '../../MultilineText';
import { observer } from 'mobx-react';

interface Props {
  question?: string,
  description?: string
}

type LocalStyles = 'questionHeader';

const localStyles: StyleRulesCallback<LocalStyles> = () => ({
  questionHeader: {
    textAlign: 'left'
  },
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class QuestionHeader extends React.Component<PropsWithStyle> {

  constructor(props: PropsWithStyle) {
    super(props)
  }

  public render() {
    return (
      <div className={this.props.classes.questionHeader}>
        {
          this.props.question !== '' &&
          <Typography variant="h6">
            {this.props.question}
          </Typography>
        }
        {
          this.props.description !== '' &&
          <Typography variant='body1' key={'description'}>
            <MultilineText text={this.props.description}/>
          </Typography>
        }
      </div>
    )
  }
}

export default withStyles(localStyles)(QuestionHeader)
